import { Visit } from '@dreryk/egabinet-visit-frontend-api';

import { Scroll } from '@dreryk/react-components';

import { ReferralToRehabilitationForm } from './ReferralToRehabilitationForm/ReferralToRehabilitationForm';
import { ReferralToRehabilitationPanelLoader } from './ReferralToRehabilitationPanel.loader';
import { ReferralToRehabilitationRouteLeavingGuard } from './ReferralToRehabilitationRouteLeavingGuard';
import { ReferralToRehabilitationSendAction } from './ReferralToRehabilitationSendAction/ReferralToRehabilitationSendAction';

type ReferralToRehabilitationPanelProps = {
   readonly visit: Visit;
};

export const ReferralToRehabilitationPanel = (props: ReferralToRehabilitationPanelProps): JSX.Element => {
   return (
      <Scroll testId={'referralToRehabilitation'}>
         <ReferralToRehabilitationPanelLoader visitId={props.visit.id}>
            {({ referralToRehabilitationDraft }) => (
               <ReferralToRehabilitationForm
                  referralToRehabilitationDraft={referralToRehabilitationDraft}
                  visitDiagnoses={props.visit.diagnoses}
                  visitBeginDate={props.visit.beginDate}
               >
                  {({ handleSubmit, handleSubmitDraft, formState, reset }) => (
                     <>
                        <ReferralToRehabilitationSendAction
                           visitId={props.visit.id}
                           handleSubmit={handleSubmit}
                           onSuccess={reset}
                        />
                        <ReferralToRehabilitationRouteLeavingGuard
                           formState={formState}
                           visitId={props.visit.id}
                           handleSubmitDraft={handleSubmitDraft}
                        />
                     </>
                  )}
               </ReferralToRehabilitationForm>
            )}
         </ReferralToRehabilitationPanelLoader>
      </Scroll>
   );
};
